{
  "title": "Telepathy",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level evocation",
  "level": 8,
  "castingTime": "1 action",
  "range": "Unlimited",
  "components": "V, S, M (a pair of linked silver rings)",
  "duration": "24 hours",
  "description": [
    "You create a telepathic link between yourself and a willing creature with which you are familiar. The creature can be anywhere on the same plane of existence as you. The spell ends if you or the target are no longer on the same plane.",
    "Until the spell ends, you and the target can instantaneously share words, images, sounds, and other sensory messages with one another through the link, and the target recognizes you as the creature it is communicating with. The spell enables a creature with an Intelligence score of at least 1 to understand the meaning of your words and take in the scope of any sensory messages you send to it."
  ],
  "spellLists": ["wizard"]
}
